import { useEffect } from 'react';
import AACChromeAPI from '@amzn/aac-chrome-api';
import { useDispatch } from 'react-redux';
import { ChromeConfig, updateChromeConfiguration } from 'src/app/slice';
import { ChromeConfigurationChangeEvent } from 'src/commons/types';
import { toPlainData } from 'src/commons/utils/toPlainData';

// we can slowly deprecate this in favour of using ChromeConfigContextProvider
export const useChromeConfigurationListener = (): void => {
  const dispatch = useDispatch();
  const eventListenerFn = (event: ChromeConfigurationChangeEvent) => {
    dispatch(
      updateChromeConfiguration(
        toPlainData<ChromeConfig>(event.detail.chromeConfiguration),
      ),
    );
  };
  useChromeConfigurationListenerWithCallback(eventListenerFn);
};

export const useChromeConfigurationListenerWithCallback = (
  callback: (event: ChromeConfigurationChangeEvent) => void,
): void => {
  useEffect(() => {
    AACChromeAPI.getCommonEventTarget().addEventListener(
      'ChromeConfigurationChange',
      callback as unknown as EventListener,
    );

    return () => {
      AACChromeAPI.getCommonEventTarget().removeEventListener(
        'ChromeConfigurationChange',
        callback as unknown as EventListener,
      );
    };
  }, []);
};
